import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { TrustpilotService } from 'src/app/services/trustpilot/trustpilot.service';

@Component({
  selector: 'app-trustbox-testimonials-desktop',
  templateUrl: './trustbox-testimonials-desktop.component.html'
})
export class TrustboxTestimonialsDesktopComponent implements AfterViewInit {
  @ViewChild('trustbox') private trustbox?: ElementRef<HTMLElement>;

  constructor(private trustpilotService: TrustpilotService) {}

  ngAfterViewInit(): void {
    this.trustpilotService.render(this.trustbox?.nativeElement);
  }
}
